export const leadCaptureConfigured = Boolean(
  import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY && import.meta.env.VITE_SUPABASE_LEADS_TABLE,
);

export async function submitLead(payload) {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const table = import.meta.env.VITE_SUPABASE_LEADS_TABLE;

  if (!url || !anonKey || !table) {
    return { preview: true };
  }

  const { createClient } = await import("@supabase/supabase-js");
  const supabase = createClient(url, anonKey, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
  const { error } = await supabase.from(table).insert({
    ...payload,
    project: "La Courbe Tower",
    source: "landing-page",
  });

  if (error) throw error;
  return { preview: false };
}
